import { createAction, props } from '@ngrx/store';
import {
  AiAssessmentDocCreateRequest,
  AiAssessmentDocUpdateRequest,
  DocRenameRequest,
  DocumentDuplicateResponse,
  WorkspaceItem,
  WorkspaceMoveRequest
} from '@primatoo-ms-organization';
import { ValidateDocumentRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/ValidateDocumentRequest';
import { UiDocumentItem } from '@pt/pt-models';
import { UpdateDocResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/UpdateDocResponse';

export const createAiAssessment = createAction('[AiAssessment] Create AiAssessment', props<{
  request: AiAssessmentDocCreateRequest
}>());
export const createAiAssessmentSuccess = createAction('[AiAssessment] Create AiAssessment Success', props<{
  id: number
}>());
export const createAiAssessmentFailed = createAction('[AiAssessment] Create AiAssessment Failed', props<{
  error: any
}>());

export const updateAiAssessment = createAction('[AiAssessment] Update Ai Assessment', props<{
  id: number,
  request: AiAssessmentDocUpdateRequest
}>());
export const updateAiAssessmentSuccess = createAction('[AiAssessment] Update Ai Assessment Success', props<{
  response: UpdateDocResponse
}>());
export const updateAiAssessmentFailed = createAction('[AiAssessment] Update Ai Assessment Failed', props<{
  error: any
}>());

export const renameAiAssessment = createAction('[folder] Rename Ai Assessment', props<{
  id: number,
  request: DocRenameRequest
}>());
export const renameAiAssessmentSuccess = createAction('[folder] Rename Ai Assessment Success', props<{ id: number }>());
export const renameAiAssessmentFailed = createAction('[folder] Rename Ai Assessment Failed', props<{ error: any }>());

export const publishAiAssessmentWithConfirm = createAction('[AiAssessment] Publish Ai Assessment with confirm', props<{
  docId: number,
  skipBack?: boolean,
  hideInfo?: boolean
}>());
export const publishAiAssessment = createAction('[AiAssessment] Publish Ai Assessment', props<{
  docId: number,
  skipBack?: boolean
}>());
export const publishAiAssessmentSuccess = createAction('[AiAssessment] Publish Ai Assessment Success');
export const publishAiAssessmentFailed = createAction('[AiAssessment] Publish Ai Assessment Failed', props<{
  error: any
}>());

export const moveAiAssessment = createAction('[AiAssessment] Move AiAssessment',
  props<{ id: number, workspaceMoveRequest: WorkspaceMoveRequest }>());
export const moveAiAssessmentSuccess = createAction('[AiAssessment] Move AiAssessment Success', props<{
  item: WorkspaceItem
}>());
export const moveAiAssessmentFailed = createAction('[AiAssessment] Move AiAssessment Failed', props<{ error: any }>());

export const duplicateAiAssessment = createAction('[AiAssessment] Duplicate AiAssessment', props<{
  id: number,
  request: AiAssessmentDocCreateRequest
}>());
export const duplicateAiAssessmentSuccess = createAction('[AiAssessment] Duplicate AiAssessment success', props<{
  response: DocumentDuplicateResponse
}>());
export const duplicateAiAssessmentFailed = createAction('[AiAssessment] Duplicate AiAssessment failed', props<{
  error: any
}>());

export const deleteAiAssessment = createAction('[AiAssessment] Delete AiAssessment', props<{ id: number }>());
export const deleteAiAssessmentSuccess = createAction('[AiAssessment] Delete AiAssessment Success');
export const deleteAiAssessmentFailed = createAction('[AiAssessment] Delete AiAssessment Failed', props<{
  error: any
}>());

export const reopenAiAssessmentWithConfirm = createAction('[AiAssessment] Reopen AiAssessment with confirm', props<{
  id: number
}>());
export const reopenAiAssessment = createAction('[AiAssessment] Reopen AiAssessment', props<{ id: number }>());
export const reopenAiAssessmentSuccess = createAction('[AiAssessment] Reopen AiAssessment Success', props<{
  id: number
}>());
export const reopenAiAssessmentFailed = createAction('[AiAssessment] Reopen AiAssessment Failed', props<{
  error: any
}>());

export const validateAiAssessmentWithConfirm = createAction('[AiAssessment] Validate document with confirm', props<{
  document: UiDocumentItem,
  skipBack?: boolean
}>());
export const validateAiAssessment = createAction('[AiAssessment] Validate document',
  props<{ document: UiDocumentItem, request: ValidateDocumentRequest, skipBack?: boolean }>());
export const validateAiAssessmentSuccess = createAction('[AiAssessment] Validate document Success');
export const validateAiAssessmentFailed = createAction('[AiAssessment] Validate document Failed', props<{
  error: any
}>());
export const createSnapshotSuccess = createAction('[AiAssessment] Create Snapshot Success');
